if($('.type-detail').length){
    $('.extended-description table tr').each(function(){
        if($(this).find('th').text().includes('#uzitecneOdkazy')){
            $(this).hide()
            if(!$('#tab-content #customLinks').length){
                $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tabLinks" data-width=""><a href="#customLinks" class="shp-tab-link" role="tab" data-toggle="tab" aria-expanded="false">Užitečné odkazy</a></li>')
                $('#tab-content').append('<div id="customLinks" class="tab-pane fade" role="tabpanel"><div class="tab-mobil tab-parametry">Užitečné odkazy</div><h3>Užitečné odkazy</h3><p>Chcete se o našich produktech dozvědět více informací?<br>Přečtěte si některý z našich článků.</p><div class="blogFeed"></div></div>')
            }
            if($('body.mobile')){
               
            }
            
            var customInfo = $(this).closest('tr').find('td').text().split('#')
            var customImage = $(this).find('.show-tooltip').attr('title')
            var customLinks = '<div class="ItemPost">'
                customLinks += '<div class="image"><a href="'+customInfo[1]+'"><img src="'+customImage+'" alt="'+customInfo[0]+'"></a></div>'
                customLinks += '<div class="text"><a href="'+customInfo[1]+'"><span class="link">'+customInfo[0]+'</span></a></div>'
            customLinks += '</div>'
            $('#tab-content #customLinks .blogFeed').append(customLinks)
            
        }
    })

    if($('#p-detail-tabs li[data-testid="tabRelatedFiles"]') || $('#p-detail-tabs li[data-testid="tabRelatedVideos"]')){
        $('#productVideos iframe').wrap('<div class="iframeVideo"></div>')
        $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tabInstructions" data-width=""><a href="#productInstructions" class="shp-tab-link" role="tab" data-toggle="tab" aria-expanded="false">Návod k použití</a></li>')
        $('#tab-content').append('<div id="productInstructions" class="tab-pane fade" role="tabpanel"><div class="tab-mobil tab-parametry">Návod k použití</div></div>')
        $('#productInstructions').append($('#productVideos').html())
        $('#productInstructions').append('<ul>'+$('#relatedFiles').html()+'</ul>')
    }
   
}